import AmexLogo from 'assets/images/amex-logo.jpg';
import DinersClubLogo from 'assets/images/diners-club-logo.png';
import DiscoverLogo from 'assets/images/discover-logo.png';
import JCBLogo from 'assets/images/jcb-logo.png';
import MasterCardLogo from 'assets/images/mastercard-logo.png';
import UnionPayLogo from 'assets/images/union-pay-logo.png';
import VisaLogo from 'assets/images/visa-logo.jpg';

export const PayFabricStatuses = Object.freeze({
  Approved: 'Approved',
  AVSFailure: 'AVSFailure',
  Declined: 'Declined',
  Denied: 'Denied',
  Failure: 'Failure',
  MoreInfo: 'More Info',
});

export function getPaymentButtonHeading(action) {
  const { type } = action;

  const lowerCase = type.toLowerCase();

  switch (lowerCase) {
    case 'full':
      return 'One time payment';

    case 'installments':
      return 'Pay Monthly';

    default:
      return '';
  }
}

export function getPaymentButtonDescription(action) {
  const { type, payload } = action;

  switch (type) {
    case 'full':
      return `Pay your balance of $${payload} in full`;

    case 'installments':
      return `3, 4, 6 monthly payments available`;

    default:
      return '';
  }
}

export function getMonthlyAmount(total) {
  const num =
    typeof total === 'number'
      ? +total.toFixed(2) * 100
      : +(+total).toFixed(2) * 100;

  const amount = (num / 6 / 100).toString(); // always show the amount for 6 installments

  return parseFloat(amount).toFixed(2);
}

export function getGAEventLabelByPaymentType(paymentType) {
  switch (paymentType) {
    case 'full':
      return 'Pay Now';

    case 'installments':
      return 'Pay Monthly';

    default:
      return '';
  }
}

export function getPaymentButtonObjects(
  amount,
  allowInstallments = false,
  paymentMethod
) {
  const keys = ['full'];
  if (paymentMethod) keys.push('savedCard');
  if (allowInstallments) keys.push('installments');

  const btnArr = keys.map((btn) => ({
    paymentType: btn,
    amount: btn === 'installments' ? getMonthlyAmount(amount) : amount,
    heading: getPaymentButtonHeading({ type: btn }),
    description: getPaymentButtonDescription({
      type: btn,
      payload: amount,
    }),
    paymentMethod: {
      ...paymentMethod,
      logo: getLogoOfPaymentMethod(paymentMethod),
    },
    isPopular: btn === 'installments',
  }));

  return btnArr;
}

function getLogoOfPaymentMethod(paymentMethod) {
  if (paymentMethod?.card_type) {
    const { card_type: cardType } = paymentMethod;

    const creditCardLogos = {
      AMERICANEXPRESS: AmexLogo,
      DINERS: DinersClubLogo,
      DISCOVER: DiscoverLogo,
      JCB: JCBLogo,
      MASTERCARD: MasterCardLogo,
      UNIONPAY: UnionPayLogo,
      VISA: VisaLogo,
    };

    return creditCardLogos[cardType] ?? '';
  }

  return '';
}

export function getErrorMessage(payFabricStatus) {
  switch (payFabricStatus) {
    case PayFabricStatuses.AVSFailure:
      return "Your card's CVV number is not correct.";

    case PayFabricStatuses.Declined:
      return 'Your card has been declined.';

    default:
      return 'There was an error processing your payment.';
  }
}
